export default {
  "boardOperations": "Board Operations",
  "manageDailyAssignmentsWorkflowAndCompletionStatus": "Manage daily assignments, workflow, and completion status.",
  "generateBoard": "Generate Board",
  "newTask": "New Task",
  "myTasks": "My Tasks",
  "staffProfileUnavailable": "(staff profile unavailable)",
  "boardNotGeneratedYet": "Board not generated yet",
  "loading": "Loading...",
  "noWorkOrders": "No work orders.",
  "staffWorkload": "Staff workload",
  "noStaffAssignmentsYet": "No staff assignments yet.",
  "selectedRoute": "Selected route",
  "selectAStaffMemberToReorderTheirRoute": "Select a staff member to reorder their route.",
  "roomStatus": "Room Status",
  "allOccupancy": "All occupancy",
  "vacant": "Vacant",
  "occupied": "Occupied",
  "reserved": "Reserved",
  "outOfOrder": "Out of order",
  "outOfService": "Out of service",
  "housekeeping": "Housekeeping",
  "allHousekeeping": "All housekeeping",
  "ready": "Ready",
  "needsCleaning": "Needs cleaning",
  "inProgress": "In Progress",
  "inspectionPending": "Inspection pending",
  "blocked": "Blocked",
  "allRoomsCurrentlyReady": "All rooms currently ready.",
  "housekeepingStaff": "Housekeeping Staff",
  "manageTheStaffRosterAvailableForHousekeepingTaskAssignment": "Manage the staff roster available for housekeeping task assignment.",
  "searchHousekeepingStaff": "Search housekeeping staff",
  "addStaff": "Add Staff",
  "staff": "Staff",
  "active": "Active",
  "inactive": "Inactive",
  "edit": "Edit",
  "deactivate": "Deactivate",
  "reactivate": "Reactivate",
  "noHousekeepingStaffRosterEntriesYet": "No housekeeping staff roster entries yet.",
  "addHousekeepingStaff": "Add Housekeeping Staff",
  "selectFromClubStaffAndAddToTheHousekeepingRoster": "Select from club staff and add to the housekeeping roster.",
  "searchStaff": "Search staff",
  "noMatchingStaff": "No matching staff.",
  "shiftPreference": "Shift preference",
  "any": "ANY",
  "am": "AM",
  "pm": "PM",
  "notes": "Notes",
  "cancel": "Cancel",
  "editHousekeepingStaff": "Edit Housekeeping Staff",
  "updateHousekeepingSpecificRosterSettings": "Update Housekeeping-specific roster settings.",
  "displayOrder": "Display order",
  "save": "Save",
  "newWorkOrder": "New Work Order",
  "createAnAdHocOrPublicAreaTaskForTheBoard": "Create an ad hoc or public area task for the board.",
  "selectType": "Select type",
  "roomCode": "Room code",
  "eG1204": "e.g. 1204",
  "selectPriority": "Select priority",
  "high": "High",
  "medium": "Medium",
  "low": "Low",
  "estimatedMinutes": "Estimated minutes",
  "dueAt": "Due at",
  "createTask": "Create Task",
  "assignStaff": "Assign staff",
  "start": "Start",
  "block": "Block",
  "complete": "Complete",
  "inspect": "Inspect",
  "clear": "Clear",
  "up": "Up",
  "down": "Down",
  "unassigned": "Unassigned",
  "assigned": "Assigned",
  "needsInspection": "Needs Inspection",
  "done": "Done",
  "closed": "Closed",
  "adHoc": "Ad Hoc",
  "publicArea": "Public Area",
  "deepClean": "Deep Clean",
  "maintenance": "Maintenance",
  "inspection": "Inspection",
  "checkout": "Checkout",
  "stayover": "Stayover",
  "room": "Room",
  "nA": "N/A",
  "invalid": "Invalid",
  "addABlockingNoteOptional": "Add a blocking note (optional):",
  "didTheRoomPassInspection": "Did the room pass inspection?",
  "inspectionNotesOptional": "Inspection notes (optional):",
  "editTask": "Edit Task",
  "newHousekeepingTask": "New Housekeeping Task",
  "roomNumber": "Room {number}",
  "assignedStaff": "Assigned Staff",
  "scheduledTime": "Scheduled Time",
  "serviceType": "Service Type",
  "dailyCleaning": "Daily Cleaning",
  "checkoutCleaning": "Checkout Cleaning",
  "deepCleaning": "Deep Cleaning",
  "pending": "Pending",
  "completed": "Completed",
  "onHold": "On Hold",
  "urgent": "Urgent",
  "updateTask": "Update Task",
  "housekeepingBoard": "Housekeeping Board",
  "visualBoardOfRoomStatusesAndCleaningTasks": "Visual board of room statuses and cleaning tasks.",
  "noHousekeepingTasksFound": "No housekeeping tasks found.",
  "createFirstTask": "Create First Task",
  "searchingStaff": "Searching staff...",
  "typeAtLeast2CharactersToSearch": "Type at least 2 characters to search.",
  "noResultsFound": "No results found.",
  "boardName": "Board: {name}",
  "dueDate": "Due: {date}",
  "assignedName": "Assigned: {name}",
  "shiftShiftOrderOrder": "Shift: {shift} • Order: {order}",
  "countMinutesMin": "{count} • {minutes} min",
  "unableToCompleteThisHousekeepingRequestPleaseTryAgain": "Unable to complete this housekeeping request. Please try again.",
  "staffSearchIsUnavailablePleaseTryAgain": "Staff search is unavailable. Please try again.",
  "errors": {
    "invalid_request": "Invalid housekeeping request.",
    "room_not_found": "Room not found.",
    "not_found": "Housekeeping record not found.",
    "invalid_status": "Invalid status.",
    "invalid_status_transition": "This status transition is not allowed.",
    "staff_not_found": "Staff member not found.",
    "board_required": "Generate a board before assigning work.",
    "invalid_shift_preference": "Invalid shift preference.",
    "invalid_display_order": "Enter a valid display order.",
    "no_updates": "No changes to save."
  },
  "enums": {
    "status": {
      "queued": "Unassigned",
      "assigned": "Assigned",
      "in_progress": "In Progress",
      "blocked": "Blocked",
      "needs_inspection": "Needs Inspection",
      "done": "Done",
      "closed": "Closed",
      "pending": "Pending",
      "completed": "Completed",
      "on_hold": "On Hold",
      "ready": "Ready",
      "needs_cleaning": "Needs cleaning",
      "inspected": "Inspection pending",
      "cancelled": "Cancelled"
    },
    "type": {
      "ad_hoc": "Ad Hoc",
      "public_area": "Public Area",
      "deep_clean": "Deep Clean",
      "maintenance": "Maintenance",
      "inspection": "Inspection",
      "checkout": "Checkout",
      "stayover": "Stayover",
      "daily_cleaning": "Daily Cleaning",
      "checkout_cleaning": "Checkout Cleaning",
      "deep_cleaning": "Deep Cleaning",
      "checkout_clean": "Checkout clean",
      "stayover_clean": "Stayover clean",
      "arrival_refresh": "Arrival refresh"
    },
    "priority": {
      "high": "High",
      "medium": "Medium",
      "low": "Low",
      "urgent": "Urgent"
    },
    "occupancy": {
      "vacant": "Vacant",
      "occupied": "Occupied",
      "reserved": "Reserved",
      "out_of_order": "Out of order",
      "out_of_service": "Out of service"
    },
    "shift": {
      "ANY": "Any",
      "AM": "AM",
      "PM": "PM"
    }
  },
  "status": "Status",
  "type": "Type",
  "priority": "Priority",
  "occupancy": "Occupancy",
  "shift": "Shift",
  "boardDate": "Board date",
  "requiredField": "Complete this required field.",
  "generatedBoardName": "Housekeeping Board {date} {shift}"
};
